import { eachMonthOfInterval, format } from 'date-fns';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { Container, Header, Loader, Message, Segment } from 'semantic-ui-react';
import { ToastError } from 'utils';
import { ProStatsCallsView } from './pro-stats-calls-view';
import { CallCountByMonth } from './pro-stats-calls-repository';

type Props = {
  fetchCalls: () => Promise<CallCountByMonth>;
  startDate: Date;
  endDate: Date;
};

type ChartData = {
  Date: string;
  dateISO: string;
  'Appels uniques': number;
  Appels: number;
}[];

export const ProStatsCallsContainer: FunctionComponent<Props> = ({
  fetchCalls,
  startDate,
  endDate,
}) => {
  const [chartData, setChartData] = useState<ChartData>();
  const [totalCount, setTotalCount] = useState<number>(0);
  const [uniqTotalCount, setUniqTotalCount] = useState<number>(0);
  const [error, setError] = useState();

  useEffect(() => {
    const fetch = async (): Promise<void> => {
      const data = await fetchCalls().catch((error) => {
        ToastError('Erreur', "Impossible d'afficher les stats d'appel");
        setError(error);
        throw error;
      });

      setTotalCount(
        data.reduce((accumulator, value) => accumulator + value.count, 0),
      );

      setUniqTotalCount(
        data.reduce((accumulator, value) => accumulator + value.uniqueCount, 0),
      );

      const months = eachMonthOfInterval({ start: startDate, end: endDate });

      const newChartData = months.map((month) => {
        const monthString = format(month, 'MM/yyyy');

        const monthData = data.find(
          (data) => format(new Date(data.month), 'MM/yyyy') === monthString,
        );

        if (monthData?.count) {
          return {
            Date: monthString,
            dateISO: format(month, 'yyyy-MM'),
            'Appels uniques': monthData.uniqueCount,
            Appels: monthData.count,
          };
        } else {
          return {
            Date: monthString,
            dateISO: format(month, 'yyyy-MM'),
            'Appels uniques': 0,
            Appels: 0,
          };
        }
      });

      newChartData.sort((a, b) => a.dateISO.localeCompare(b.dateISO));

      setChartData(newChartData);
    };
    fetch();
  }, [fetchCalls]);

  if (error) return <>Error!</>;

  if (!chartData) {
    return (
      <Segment style={{ height: '576px' }}>
        <Loader active>Chargement...</Loader>
      </Segment>
    );
  }

  if (totalCount === 0) {
    return (
      <Container fluid style={{ height: '576px' }}>
        <Header as="h2">Appels</Header>
        <Message>Pas de stats</Message>
      </Container>
    );
  }

  return (
    <ProStatsCallsView
      chartData={chartData}
      totalCount={totalCount}
      uniqTotalCount={uniqTotalCount}
    />
  );
};
